export default {
  additionalInformation: 'Additional Information',
  requiredFields: 'Required Fields',
  optionalFields: 'Optional Fields',
  loadError: 'Error loading dynamic fields',

  // Field type labels (fallback if not in definition)
  fieldTypes: {
    string: 'Text',
    integer: 'Whole Number',
    float: 'Decimal Number',
    boolean: 'Yes/No',
    select: 'Selection'
  },

  // Context labels
  contexts: {
    reservation: 'Reservation',
    borrowing: 'Pickup/Borrowing',
    return: 'Return'
  },

  // Validation messages
  validation: {
    required: 'This field is required',
    minLength: 'Minimum length is {min} characters',
    maxLength: 'Maximum length is {max} characters',
    min: 'Minimum value is {min}',
    max: 'Maximum value is {max}',
    pattern: 'Invalid format',
    invalidType: 'Invalid value type'
  },

  // Manager UI
  manager: {
    title: 'Dynamic Borrowing Fields',
    description: 'Configure dynamic fields that will be requested during reservation, borrowing, or return of resources in this category.',
    addField: 'Add Field',
    newField: 'New Field',
    fieldKey: 'Field Key',
    keyHelp: 'Unique identifier (lowercase, no spaces)',
    fieldType: 'Type',
    label: 'Label',
    labelPlaceholder: 'Field label shown to users',
    helpText: 'Help Text',
    helpTextPlaceholder: 'Optional help text',
    placeholder: 'Placeholder',
    placeholderExample: 'e.g., 50000',
    required: 'Required field',
    descriptionField: 'Show as description in borrowing card',
    contexts: 'When to request this field',
    contextsHelp: 'Select one or more',
    allContexts: 'All',
    options: 'Options',
    addOption: 'Add option...',
    noFields: 'No dynamic fields configured yet.',
    keyAndLabelRequired: 'Field key and label are required',
    keyAlreadyExists: 'A field with this key already exists',
    selectNeedsOptions: 'Select field must have at least one option',
    optionAlreadyExists: 'This option already exists',
    confirmDelete: 'Are you sure you want to delete this field?',
    dragHint: 'Drag and drop fields to change their display order',
    editField: 'Edit Field',
    keyCannotChange: 'Field key cannot be changed',
    labelRequired: 'Label is required'
  }
};
